
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const PlusIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 15.5C51.5 13.567 49.933 12 48 12C46.067 12 44.5 13.567 44.5 15.5V44.5H15.5C13.567 44.5 12 46.067 12 48C12 49.933 13.567 51.5 15.5 51.5H44.5V80.5C44.5 82.433 46.067 84 48 84C49.933 84 51.5 82.433 51.5 80.5V51.5H80.5C82.433 51.5 84 49.933 84 48C84 46.067 82.433 44.5 80.5 44.5H51.5V15.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 15.5C51.5 13.567 49.933 12 48 12C46.067 12 44.5 13.567 44.5 15.5V44.5H15.5C13.567 44.5 12 46.067 12 48C12 49.933 13.567 51.5 15.5 51.5H44.5V80.5C44.5 82.433 46.067 84 48 84C49.933 84 51.5 82.433 51.5 80.5V51.5H80.5C82.433 51.5 84 49.933 84 48C84 46.067 82.433 44.5 80.5 44.5H51.5V15.5Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 15.5C51.5 13.567 49.933 12 48 12C46.067 12 44.5 13.567 44.5 15.5V44.5H15.5C13.567 44.5 12 46.067 12 48C12 49.933 13.567 51.5 15.5 51.5H44.5V80.5C44.5 82.433 46.067 84 48 84C49.933 84 51.5 82.433 51.5 80.5V51.5H80.5C82.433 51.5 84 49.933 84 48C84 46.067 82.433 44.5 80.5 44.5H51.5V15.5Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M51.5 15.5C51.5 13.567 49.933 12 48 12C46.067 12 44.5 13.567 44.5 15.5V44.5H15.5C13.567 44.5 12 46.067 12 48C12 49.933 13.567 51.5 15.5 51.5H44.5V80.5C44.5 82.433 46.067 84 48 84C49.933 84 51.5 82.433 51.5 80.5V51.5H80.5C82.433 51.5 84 49.933 84 48C84 46.067 82.433 44.5 80.5 44.5H51.5V15.5Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
